import React, { Component, Fragment } from 'react'
import { translate } from '../Services/translation'

const ContactForm = ({
    contact = {},
    supportTypes = {},
    countries = {},
    claimCategories = {},
    contactFormSent = {},
    errors = {},
    onChange,
    onSubmit,
    onFileChange,
}) => (
    <Fragment>
        <div className="row">
            <div className="columns small-12">
                <h2>{translate('contact.title')}</h2>
            </div>
        </div>

        <div
            className="row"
            style={{ display: contactFormSent.id ? 'none' : 'block' }}
        >
            <div className="columns small-12">
                <label className="form__label" htmlFor="name">
                    {translate('contact.name')}
                </label>
                <input
                    className="form__input"
                    id="name"
                    name="name"
                    type="text"
                    autoComplete="name"
                    value={contact.name || ''}
                    onChange={(event) => onChange('name', event.target.value)}
                />
                {errors['name'] && (
                    <span className="form__validator--error form__validator--top-narrow">
                        {errors['name'][0]}
                    </span>
                )}
            </div>
            <div className="columns small-12">
                <label className="form__label" htmlFor="email">
                    {translate('contact.email')}
                </label>
                <input
                    className="form__input"
                    id="email"
                    name="email"
                    type="text"
                    autoComplete="email"
                    value={contact.email || ''}
                    onChange={(event) => onChange('email', event.target.value)}
                />
                {errors['email'] && (
                    <span className="form__validator--error form__validator--top-narrow">
                        {errors['email'][0]}
                    </span>
                )}
            </div>

            <div className="columns small-12">
                <label className="form__label" htmlFor="country">
                    {translate('contact.country')}
                </label>
                <select
                    className="form__input"
                    id="country"
                    value={contact.country || ''}
                    onChange={(event) =>
                        onChange('country', event.target.value)
                    }
                >
                    <option value="">
                        {translate('contact.choosecountry')}
                    </option>
                    {countries.map((country, index) => (
                        <option value={country.value} key={index}>
                            {country.text}
                        </option>
                    ))}
                </select>
                {errors['country'] && (
                    <span className="form__validator--error form__validator--top-narrow">
                        {errors['country'][0]}
                    </span>
                )}
            </div>
            <div className="columns small-12">
                <label className="form__label" htmlFor="supportType">
                    {translate('contact.supportype')}
                </label>
                <select
                    className="form__input"
                    id="supportType>"
                    value={contact.supportType || ''}
                    onChange={(event) =>
                        onChange('supportType', event.target.value)
                    }
                >
                    <option value="0">
                        {translate('contact.choosesupporttype')}
                    </option>
                    {supportTypes.map((supportType, index) => (
                        <option value={supportType.value} key={index}>
                            {supportType.text}
                        </option>
                    ))}
                </select>
                {errors['supportType'] && (
                    <span className="form__validator--error form__validator--top-narrow">
                        {errors['supportType'][0]}
                    </span>
                )}
            </div>
            {contact.supportType == 1 && (
                <div className="columns small-12" id="delivery">
                    <label className="form__label" htmlFor="orderNumber">
                        {translate('contact.ordernumber')}
                    </label>
                    <input
                        className="form__input"
                        id="orderNumber1"
                        name="orderNumber1"
                        type="text"
                        value={contact.orderNumber1 || ''}
                        onChange={(event) =>
                            onChange('orderNumber1', event.target.value)
                        }
                    />
                    {errors['orderNumber1'] && (
                        <span className="form__validator--error form__validator--top-narrow">
                            {errors['orderNumber1'][0]}
                        </span>
                    )}
                </div>
            )}
            {contact.supportType == 3 && (
                <div className="columns small-12" id="return">
                    <span className="form--info">
                        {translate('contact.returninstructions')}
                    </span>
                    <label className="form__label" htmlFor="orderNumber">
                        {translate('contact.ordernumber')}
                    </label>
                    <input
                        className="form__input"
                        id="orderNumber"
                        name="orderNumber"
                        type="text"
                        value={contact.orderNumber || ''}
                        onChange={(event) =>
                            onChange('orderNumber', event.target.value)
                        }
                    />
                </div>
            )}
            {contact.supportType == 6 && (
                <div className="columns small-12" id="cooperation">
                    <span className="form--info">
                        {translate('contact.cooperation')}
                    </span>
                </div>
            )}
            {contact.supportType == 5 && (
                <div className="columns small-12" id="B2B">
                    <p className="form--info">{translate('contact.b2b')}</p>
                </div>
            )}
            {contact.supportType == 4 && (
                <div className="columns small-12" id="complaint">
                    <span className="form--info">
                        {translate('contact.complaint')}
                    </span>
                    <label className="form__label" htmlFor="orderNumber">
                        {translate('contact.ordernumber')}
                    </label>
                    <input
                        className="form__input"
                        id="orderNumber"
                        name="orderNumber"
                        type="text"
                        value={contact.orderNumber || ''}
                        onChange={(event) =>
                            onChange('orderNumber', event.target.value)
                        }
                    />
                    {errors['orderNumber'] && (
                        <span className="form__validator--error form__validator--top-narrow">
                            {errors['orderNumber'][0]}
                        </span>
                    )}

                    {/* TODO: Upload of attachments
                <label className="form__label" htmlFor="fileUpload">{translate('contact.fileupload')}</label>
                <input className="" id="fileUpload" name="fileUpload" type="file"
                       onChange={(event) => onFileChange( event.target.value)}/>
                       */}

                    <label className="form__label" htmlFor="batchNumber">
                        {translate('contact.batchnumber')}
                    </label>
                    <input
                        className="form__input"
                        id="batchNumber"
                        name="batchNumber"
                        type="text"
                        value={contact.batchNumber || ''}
                        onChange={(event) =>
                            onChange('batchNumber', event.target.value)
                        }
                    />
                    <span className="form__validator--top-narrow form--info">
                        {translate('contact.batchnumberhelp')}
                    </span>
                    {errors['batchNumber'] && (
                        <span className="form__validator--error form__validator--top-narrow">
                            {errors['batchNumber'][0]}
                        </span>
                    )}
                    <label className="form__label" htmlFor="claimsCategory">
                        {translate('contact.claimscategory')}
                    </label>
                    <select
                        className="form__input"
                        id="claimsCategory>"
                        value={contact.claimsCategory || ''}
                        onChange={(event) =>
                            onChange('claimsCategory', event.target.value)
                        }
                    >
                        <option value="">
                            {translate('contact.chooseclaimscategories')}
                        </option>
                        {claimCategories.map((claimCategory, index) => (
                            <option value={claimCategory.value} key={index}>
                                {claimCategory.text}
                            </option>
                        ))}
                    </select>
                </div>
            )}
            <div
                className="columns small-12"
                style={{ display: contact.supportType > 4 ? 'none' : 'block' }}
            >
                <label className="form__label" htmlFor="message">
                    {translate('contact.message')}
                </label>
                <textarea
                    className="form__input--textarea form__input"
                    id="message"
                    rows="10"
                    value={contact.message || ''}
                    onChange={(event) =>
                        onChange('message', event.target.value)
                    }
                />
                {errors['message'] && (
                    <span className="form__validator--error form__validator--top-narrow">
                        {errors['message'][0]}
                    </span>
                )}
            </div>

            <div
                className="columns small-12"
                style={{ display: contact.supportType > 4 ? 'none' : 'block' }}
            >
                <button
                    className="flowbox-block--button-primary"
                    onClick={() => onSubmit(contact)}
                >
                    {translate('contact.send')}
                </button>
            </div>
        </div>
        <div
            className="row"
            style={{ display: contactFormSent.id ? 'block' : 'none' }}
        >
            <div className="columns small-12">
                <div className="form__message-box--success form__message-box form--top-padded">
                    <p className="form__message--success">
                        {translate('contact.success')}
                    </p>
                </div>
            </div>
        </div>
    </Fragment>
)

export default ContactForm
